(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/views/start.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/views/start.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.keno_xpress=_svs.keno_xpress||{};
_svs.keno_xpress.templates=_svs.keno_xpress.templates||{};
svs.keno_xpress.templates.start = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"reactContainer\" class=\"react-container\"></div>\n";
},"useData":true});
Handlebars.partials['svs-keno_xpress-start'] = svs.keno_xpress.templates.start;
})(svs, Handlebars);


 })(window);